export const shouldBlockMembershipGraceRequest = (config, readOnly) => {
  if (!readOnly) return false
  const method = String(config?.method || 'GET').toUpperCase()
  const isWriteMethod = !['GET', 'HEAD', 'OPTIONS'].includes(method)
  return isWriteMethod
    && config?.membershipGraceRead !== true
    && config?.membershipAccessExempt !== true
}
